interface IProps {
    color?: string;
    className?: string;
}

export const BGCardPage = (props: IProps) => {
    const { color = "#BC9067", className = "" } = props;

    return (
        <svg width="100%" height="300"
            className={className}
            viewBox="0 0 393 262" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g filter="url(#filter0_bd_3109_109138)">
                <ellipse cx="197" cy="74.5" rx="290" ry="151.5" fill={color} />
            </g>
        </svg>


    );
};